/* GLOBAL INTERFACE STORE */
import {Module} from 'vuex'
import {InterfaceState, RootState} from '@/types/store/states'

const store: Module<InterfaceState, RootState> = {
  namespaced: true,
  state: {
    networkErrorVissible: false,
    preloaderBarShow: false,
    disableSelect: false,
    httpRequests: [],
    styles: {},
  },
  getters: {},
  mutations: {
    networkErrorVissible: (state, vissible) => {
      state.networkErrorVissible = vissible !== undefined ? vissible : !state.networkErrorVissible
    },
    disableSelect: (state, disabled) => {
      state.disableSelect = disabled
    },
    setLoaderBar (state, payload) {
      state.preloaderBarShow = payload
    },
    addRequest: (state, httpRequest) => {
      state.httpRequests.push(httpRequest);
      // console.log(state.httpRequests)
    },
    removeRequest: (state, httpRequest) => {
      state.httpRequests.splice(state.httpRequests.indexOf(httpRequest), 1)
    }
  },
  actions: {}
}
export default store